type TornadoItem = {
  label: string;
  neg: number;
  pos: number;
};

interface SensitivityTornadoCardProps {
  items: TornadoItem[];
  insightTitle: string;
  insightText: string;
  emptyState?: React.ReactNode;
  isShowTags?: boolean;
}

function TornadoRow({ label, neg, pos, max }: { label: string; neg: number; pos: number; max: number }) {
  const logMax = Math.log(max + 1);
  const negW = (Math.log(Math.abs(neg) + 1) / logMax) * 90;
  const posW = (Math.log(pos + 1) / logMax) * 90;

  return (
    <div className="cma-tornado-row">
      <div className="cma-tornado-label">{label}</div>
      <div className="cma-tornado-track">
        <div className="cma-tornado-side cma-tornado-side-neg">
          <div className="cma-tornado-bar cma-tornado-bar-neg" style={{ width: `${negW}%` }}>
            <span className="cma-tornado-value cma-tornado-value-neg">-{Math.abs(neg).toLocaleString()}K</span>
          </div>
        </div>
        <div className="cma-tornado-side cma-tornado-side-pos">
          <div className="cma-tornado-bar cma-tornado-bar-pos" style={{ width: `${posW}%` }}>
            <span className="cma-tornado-value cma-tornado-value-pos">+{pos.toLocaleString()}K</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export function SensitivityTornadoCard({ items, insightTitle, insightText, emptyState, isShowTags = true }: SensitivityTornadoCardProps) {
  const tornadoMax = items.length > 0 ? Math.max(...items.map((t) => t.pos)) : 1;

  return (
    <div className="cma-card">
      <div className="cma-card-header">
        <div>
          <div className="cma-card-title">Sensitivity Analysis - Tornado Diagram</div>
          <div className="cma-card-subtitle">Impact of +/-10% change per cost driver ($M swing)</div>
        </div>
        {isShowTags && <span className="cma-card-badge cma-card-badge-mid">SENSITIVITY</span>}
      </div>

      {items.length > 0 ? (
        <>
          <div className="cma-tornado-list">
            {items.map((t) => (
              <TornadoRow key={t.label} {...t} max={tornadoMax} />
            ))}
          </div>
          <div className="cma-insight-box">
            <div className="cma-insight-title">{insightTitle}</div>
            <div className="cma-insight-text">{insightText}</div>
          </div>
        </>
      ) : (
        emptyState ?? <div className="cma-no-records">No Records Found</div>
      )}
    </div>
  );
}
